import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DeletePopup from "../GardenPopup/DeletePopup"
import WorkSubTypePopup from "./WorkSubTypePopup"
import { useSearchParams } from "react-router-dom"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { WorkSubTypeDeleteAPI, WorkSubTypeTableDataAPI } from "../../../../Redux/SidebarMasterSlice/WorkSubTypeSlice"
import { Loading } from "../../../../Helper/Loading"
import { WorkSubTypeDDL } from "../../../../Components/CommonDDL/WorkSubTypeDDL"
import { WorkTypeDDL } from "../../../../Components/CommonDDL/WorkTypeDDL"
import { useTranslation } from "react-i18next"
// import { WorkSubTypeDDL } from "../../../../Components/CommonDDL/WorkSubTypeDDL"

export const WorkSubType = () => {

    const { t } = useTranslation()

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let Lang = searchParams.get("Lang")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [IsSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [WorkSubTypePopupShow, setWorkSubTypePopupShow] = useState()

    const [WorkSubType, setWorkSubType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: ''
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])



    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWorkSubTypePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setWorkSubTypePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setWorkSubTypePopupShow(false)
    }

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })
    const handleClear = () => {
        setFrom(1)
        setTo(10)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWorkSubType({
            ...WorkSubType,
            ID: 0,
            Label: 'Select...',
        })
        setWorkType({
            ...WorkType,
            ID: 0,
            Label: 'Select...',
        })

        // console.log("call")
    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_WorkSubTypeID: item.m_WorkSubTypeID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(WorkSubTypeDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WorkSubTypeDeleteData)

    useEffect(() => {
        const data = {
            M_WorkSubTypeID: WorkSubType.ID ? WorkSubType.ID : 0,
            WorkSubTypeName: '',
            M_WorkTypeID: WorkType.ID ? WorkType.ID : 0,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            Flag: ApiFlag,
            Language: Language.Label

        }
        {Language.Label != '' && dispatch(WorkSubTypeTableDataAPI({ data }))}

    }, [IsPost, To, IsClear, WorkSubType.ID, WorkType.ID, Language.Label])

    const { tableData, isLoading } = useSelector(state => state.WorkSubTypeTableData)

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                    Language={Language}
                    setLanguage={setLanguage}
                />
                <div className="wrapper p-3">
                    <Sidebar
                        Language={Language}
                        ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className="col-10">
                                    <h5 className="ps-1 py-2">{t('AdminDashboard.Admin_Sidebar_Name.Work_Sub_Type')}</h5>
                                </div>
                                <div className="col-12 mar_add_minus float-end">
                                    <i className="fa-solid fa-plus btn btn-secondary float-end mb-2"
                                        onClick={handleAddOnClick} style={{ color: "white", marginTop: '-2.5em' }}>
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                                <div className="row m-0">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">

                                                <div className="col-12 col-md-5 col-lg-3 ">
                                                    <WorkTypeDDL
                                                        WorkType={WorkType}
                                                        setWorkType={setWorkType}
                                                        Language={Language}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-5 col-lg-3">
                                                    <WorkSubTypeDDL
                                                        WorkSubType={WorkSubType}
                                                        setWorkSubType={setWorkSubType}
                                                        WorkType={WorkType}
                                                        Language={Language}
                                                    />
                                                </div>

                                                <div className="col-12 col-lg-3 col-md-1 mt-md-4 mt-lg-4">
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary"
                                                        onClick={handleClear}
                                                    >Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Work Type</th>
                                                            <th>Work Sub Type</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.workTypeName ? item.workTypeName : '-'}</td>
                                                                    <td>{item.workSubTypeName ? item.workSubTypeName : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}> <span >
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>
                                                                    </span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                            item={item}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <>No Found data</>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    IsClear={IsClear}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    WorkSubTypePopupShow ?
                        <WorkSubTypePopup
                            open={WorkSubTypePopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            Language={Language}
                        />
                        : <></>
                }
            </div>
        </>

    )
}